/*------------------------------------*\
    copy to clipboard
\*------------------------------------*/
module.exports = function(){

    if ($('.js-copy-btn').length && $('.js-copy-target').length ) {


        var copyTextareaBtn = document.querySelector('.js-copy-btn');

        copyTextareaBtn.addEventListener('click', function(event) {
          var copyTextarea = document.querySelector('.js-copy-target');
          copyTextarea.select();

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            //console.log('Copying text command was ' + msg);

            $('.js-copy-btn').text('COPIED');

          } catch (err) {
            //console.log('Oops, unable to copy');
          }
        });


    }



}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/copy.js